var React = require('react');

function Minus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 1.00378H9","stroke":"#595959","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Minus.defaultProps = {"width":"10","height":"3","viewBox":"0 0 10 3","fill":"none"};

module.exports = Minus;

Minus.default = Minus;
